// src/pages/History/EarlyModern/SpanishPortugueseColonizationGo.jsx
import React from 'react';
import QuizPage from '../../../components/QuizPageNew2';
import historyImage from '../../../assets/history/Early_Modern_Period_-_Spanish_and_Portuguese_Colonization.png';

function HistoryPageSpanishPortugueseColonizationGo() {
  return (
    <QuizPage
      title="History: Spanish and Portuguese Colonization"
      subTopic="Spanish and Portuguese Colonization"
      backgroundImage={historyImage}
      returnPath="/History-Spanish-Portuguese-Colonization"
    />
  );
}

export default HistoryPageSpanishPortugueseColonizationGo;
